/* Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

import { TranslateModule } from '@ngx-translate/core';
import { NvHigListItemContextData } from '../../../models/hig-list-item.types';

@Component({
    selector: 'nv-hig-list-item-context-cta',
    templateUrl: './nv-hig-list-item-context-cta.component.html',
    styleUrl: './nv-hig-list-item-context-cta.component.scss',
    imports: [MatButtonModule, TranslateModule]
})
export class NvHigListItemContextCtaComponent {
    data: NvHigListItemContextData;
    @Input() set cardData(x: NvHigListItemContextData) {
        this.data = x;
    }

    @Output() primaryButtonClicked = new EventEmitter<MouseEvent>();
    @Output() secondaryButtonClicked = new EventEmitter<MouseEvent>();

    primaryButtonClick(event: MouseEvent): void {
        this.primaryButtonClicked.emit(event);
    }

    secondaryButtonClick(event: MouseEvent): void {
        this.secondaryButtonClicked.emit(event);
    }
}
